<template>
  <div>
    <Header />

    <!-- 毛毛蟲 -->
    <nav aria-label="breadcrumb" class="breadcrumb_box">
      <div class="container">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/Profile" title="首頁">Home</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            International Student Application System
          </li>
        </ol>
      </div>
    </nav>

    <div class="main form form_4">
      <a accesskey="c" class="accesskey" id="accesskey_c" href="javascript:void(0);" title="中央內容區塊"
        onclick="document.getElementById('accesskey_c').scrollIntoView();">
        :::
      </a>

      <div class="container">
        <div class="box" :class="{ 'submitted-readonly': isSubmitted }">
          <div class="title">
            <h2>International Student Application System</h2>
            <div class="btn_box">
              <button class="tours_btn" @click="startTour">
                <svg width="28" height="28" viewBox="0 0 28 28">
                  <defs>
                    <clipPath id="clip-path">
                      <rect id="_3" data-name="3" width="28" height="28" transform="translate(5575 10526)" fill="none"
                        stroke="#707070" stroke-width="1" />
                    </clipPath>
                  </defs>
                  <g id="icon_instructions" transform="translate(-5575 -10526)" clip-path="url(#clip-path)">
                    <g id="_2" data-name="2" transform="translate(5575.14 10526.5)">
                      <path id="_1" data-name="1"
                        d="M23.14,21.36a1,1,0,0,0,1-1V3.42A1.929,1.929,0,0,0,22.21,1.5H8.69V19.358h-2V1.5H5.93A3.077,3.077,0,0,0,2.86,4.57V22.43c0,.011.006.021.007.032A3.069,3.069,0,0,0,5.934,25.5h17.2a1,1,0,0,0,0-2H5.934a1.07,1.07,0,0,1,0-2.14H23.14Zm-7.751-15a1.007,1.007,0,0,1,1.021,1,1,1,0,0,1-2,0,1,1,0,0,1,.979-1ZM14.41,11.19a1,1,0,0,1,2,0v3.96a1,1,0,0,1-2,0Z"
                        fill="#580d63" />
                    </g>
                  </g>
                </svg>
                Instructions
              </button>
            </div>
          </div>

          <ul class="progress_bar">
            <li v-for="(item, index) in progressItems" :key="index">
              <router-link :to="item.to" :class="['step_box', getStepClass(index)]">
                <div class="step">
                  <p v-if="index != 6">Step {{ index + 1 }}</p>
                  <p v-else>Payment</p>
                  <p>{{ item.title }}</p>
                </div>
                <div class="line"></div>
              </router-link>
            </li>
          </ul>

          <!-- 已提交提示訊息 -->
          <div v-if="isSubmitted" class="bg" style="background-color: #fff3cd; border-left: 4px solid #ffc107; padding: 15px 20px; margin-bottom: 20px;">
            <p style="margin: 0; color: #856404; font-weight: bold; font-size: 16px;">
              ⚠️ Application submitted and under review. View-only mode.
            </p>
          </div>

          <div class="bg">
            <div class="title_box description">
              <h3>{{ stepContent.title }}</h3>
            </div>

            <div v-if="stepContent.content" class="text_box" id="step1" v-html="stepContent.content"></div>
          </div>

          <!-- 載入指示器 -->
          <div v-if="isLoading" class="loading-container" style="text-align: center; padding: 40px;">
            <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
              <span class="sr-only">Loading...</span>
            </div>
            <p style="margin-top: 20px; font-size: 16px;">Loading application data...</p>
          </div>

          <!-- 已申請學程列表 -->
          <div v-else class="bg">

            <template v-if="userPrograms.length > 0">
              <div class="block bg" v-for="(program, programIndex) in userPrograms" :key="program.pId">
                <div class="title_box">
                  <h3>{{ program.programInfo.name_EN || program.programInfo.name }}</h3>
                </div>
                <template v-if="program.departmentFiles.length > 0">
                  <template v-for="(file, fileIndex) in program.departmentFiles">
                    <div class="form-group file_box full">
                      <label :for="'dept-file-' + program.pId + '-' + file.afId">
                        <span v-if="file.isRequired" class="required">*</span>
                        {{ file.name_EN || file.name }}
                      </label>
                      <div class="file_input">
                        <input type="file" class="form-control" :id="'dept-file-' + program.pId + '-' + file.afId"
                          @change="handleDepartmentFileChange($event, program.pId, file.afId)" :disabled="uploading || isSubmitted"/>
                        <div class="upload">{{ uploading ? 'Uploading...' : 'Upload' }}</div>
                      </div>
                      <div>
                        <!-- 顯示檔案說明 -->
                        <div v-if="file.content" v-html="file.content" class="notice"></div>
                        <!-- 顯示已上傳的檔案資訊 -->
                        <div v-if="file.simpleFile || file.uploadedFile" class="uploaded-file-info">
                          <a v-if="file.simpleFile"
                            :href="$store.state.src + $store.state.subDirectory + file.simpleFile" target="_blank"
                            class="file_a" style="background-color: #6c757d; color: #FFFFFF;">
                            Simple File
                          </a>
                          <a v-if="file.uploadedFile"
                            :href="$store.state.src + $store.state.subDirectory + file.uploadedFile.url" target="_blank"
                            class="file_a">
                            Uploaded File ({{ formatUploadTime(file.uploadedFile.createTime) }})
                          </a>
                        </div>
                      </div>
                    </div>
                    <hr v-if="fileIndex < program.departmentFiles.length - 1" class="file_hr" />
                  </template>
                </template>
                <template v-else>
                  <div class="form-group file_box full">
                    <p style="margin: 0; color: #999;">No additional document requirements for this program</p>
                  </div>
                </template>
              </div>
            </template>
            <template v-else>
              <div style="padding: 40px; text-align: center; background: #f9f9f9; border-radius: 8px; width: 100%;">
                <p style="margin: 0; color: #999; font-size: 16px;">
                  No programs have been applied for yet. Please go to Step 2 to select a program.
                </p>
                <button class="btn" @click="gotoApply_2" style="margin-top: 20px;">
                  Go to Step 2
                </button>
              </div>
            </template>


          </div>

          <div class="btn_box">
            <button class="btn" @click="gotoPrev" :disabled="isSubmitted">Previous</button>
            <button class="btn" @click="gotoNext" :disabled="isSubmitted">Next</button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import applyStudentService from "@/services/applyStudent.js";
import { validateFile } from "@/utils/fileHelper.js";
import { uploadSingleFile } from "@/utils/uploadHelper.js";
import Swal from "sweetalert2";

import { driver } from "driver.js";

export default {
  name: "Form_5",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      // 進度步驟
      currentStep: 4, // 表示第5步（index 4）
      progressItems: [
        { to: "/Apply/1", title: "Fill out online application form" },
        { to: "/Apply/2", title: "Apply for a program" },
        {
          to: "/Apply/3",
          title:
            "Fill out Recommenders (Do Not Fill Out Without Notifying Your Recommenders in Advance.)",
        },
        { to: "/Apply/4", title: "Upload Required Documents 1" },
        { to: "/Apply/5", title: "Upload Required Documents 2" },
        { to: "/Apply/Check", title: "Review & Submit" },
        { to: "/Apply/Pay", title: "Pay Application Fee" },
      ],

      driverObj: null,
      arr: [
        {
          element: "#step1",
          popover: {
            description: "Department",
            side: "top",
            align: "start",
          },
        },
      ],

      //其他資料的新增和刪除
      fileItems: [{ id: Date.now(), file: null }],

      // 步驟內容
      stepContent: {
        step: 5,
        title: 'Step 5',
        content: '',
        applyInfo: null
      },

      // 申請表ID
      asId: null,
      isSubmitted: false, // 申請是否已提交

      // 申請的學程列表（包含系所文件）
      userPrograms: [],

      // 所有可用學程
      allPrograms: [],

      // 載入狀態
      isLoading: false,

      // 上傳中的狀態
      uploading: false,

      // 額外支援文件（最多5個）
      additionalFiles: [],
      maxAdditionalFiles: 5,

      aId: null, // 申請學期梯次ID
    };
  },

  watch: {
    // 監控 isSubmitted 狀態並禁用所有表單元素
    isSubmitted: {
      handler(newValue) {
        this.$nextTick(() => {
          this.toggleFormElements(newValue);
        });
      },
      immediate: false
    }
  },

  mounted() {
    window.scrollTo(0, 0);
    this.initializeForm();

    // 初始化時檢查並禁用表單元素（如果已提交）
    this.$nextTick(() => {
      if (this.isSubmitted) {
        this.toggleFormElements(true);
      }
    });
  },

  methods: {
    // ========== 頁面初始化 ==========

    /**
     * 初始化表單 - 載入所有必要資料
     */
    async initializeForm() {
      this.isLoading = true;
      try {
        const checkResult = await applyStudentService.checkUserApplication();
        if (!checkResult.success || !checkResult.data ||
          !checkResult.data?.isReview ||
          checkResult.data?.isAgree != 1) {
          Swal.fire({
            icon: "warning",
            title: "Eligibility review not completed",
            text: "Please complete the dual citizenship check and agree to the terms and conditions first.",
            confirmButtonText: "OK"
          }).then(() => {
            this.$router.push("/Profile");
          });
          return;
        }

        // 載入使用者申請表資料和學程
        await this.loadUserApplication();

        // 載入步驟內容
        await this.loadStepContent();

      } catch (error) {
        console.error("Form initialization error:", error);
        alert("Failed to initialize form. Please refresh the page.");
      } finally {
        this.isLoading = false;
      }
    },

    // 載入使用者申請表資料
    async loadUserApplication() {
      const result = await applyStudentService.getUserApplication();
      if (result.success && (!result.data || !result.data.hasApplication)) {
        // 顯示請先完成基本資料並跳轉回Apply/1頁面
        Swal.fire({
          icon: "warning",
          title: "Incomplete Basic Information",
          text: "Please complete your basic information first.",
          confirmButtonText: "OK"
        }).then(() => {
          this.$router.push("/Apply/1");
        });
      }
      if (result.success && result.data) {
        this.aId = result.data.aId;
        this.asId = result.data.asId;
        this.isSubmitted = result.data.isSubmitted || false;

        // 解析使用者申請的學程
        if (result.data.applyPrograms) {
          try {
            const programIds = JSON.parse(result.data.applyPrograms);
            await this.loadProgramsWithFiles(programIds);
          } catch (error) {
            console.error("Error parsing applyPrograms:", error);
            this.userPrograms = [];
          }
        }
      }
    },

    // 載入學程資訊及其系所文件
    async loadProgramsWithFiles(programIds) {
      // 先載入所有可用學程
      const programsResult = await applyStudentService.getActiveApplyPrograms(this.aId);
      if (programsResult.success && programsResult.data) {
        // 解析 API 回傳的資料結構
        const { programs, colleges, departments } = programsResult.data;
        this.allPrograms = programs || [];

        // 為每個申請的學程載入系所文件
        this.userPrograms = [];
        for (const pId of programIds) {
          const program = this.allPrograms.find(p => p.pId === pId);
          if (program) {
            // 載入該學程的系所文件
            const filesResult = await applyStudentService.getDepartmentUploadFiles({
              asId: this.asId,
              pId: pId
            });

            this.userPrograms.push({
              pId: pId,
              programInfo: program,
              departmentFiles: filesResult.success ? filesResult.data : []
            });
          }
        }
      }
    },

    // 載入步驟內容
    async loadStepContent() {
      const result = await applyStudentService.getActiveApplyStepContent(5, this.aId);
      if (result.success && result.data) {
        this.stepContent = result.data;
        if (!this.stepContent.title) {
          this.stepContent.title = 'Step 5';
        }
      } else {
        // 使用預設值
        this.stepContent = {
          step: 5,
          title: 'Step 5',
          content: '',
          applyInfo: null
        };
      }
    },

    // 進度步驟 不同狀態增加不同class
    getStepClass(index) {
      if (index < this.currentStep) {
        return "done"; // 已完成
      } else if (index === this.currentStep) {
        return "filling"; // 目前步驟
      }
    },

    startTour() {
      // 建立 driver 實例，開始導覽
      this.driverObj = driver({
        showProgress: true,
        progressText: "{{current}}/{{total}}",
        showButtons: true,
        nextBtnText: "Next",
        prevBtnText: "Back",
        doneBtnText: "End Tour",
        animate: false,
        steps: this.arr,
      });

      this.driverObj.drive();
    },

    // 處理系所文件選擇
    async handleDepartmentFileChange(event, pId, afId) {
      const file = event.target.files[0];
      if (!file) return;

      // 驗證檔案
      const validation = validateFile(file, {
        maxSizeMB: 10,
        allowedTypes: ['.pdf', '.jpg', '.jpeg', '.png', '.doc', '.docx']
      });

      if (!validation.valid) {
        alert(validation.message);
        event.target.value = '';
        return;
      }

      // 立即上傳檔案
      await this.uploadDepartmentFile(file, pId, afId);
    },

    // Upload department document
    async uploadDepartmentFile(file, pId, afId) {
      if (this.uploading) {
        return;
      }

      try {
        this.uploading = true;

        // 使用新的上傳方法，會自動顯示進度
        const result = await uploadSingleFile({
          asId: this.asId,
          file: file,
          pId: pId, // 使用學程ID
          afId: afId
        });

        // 上傳成功後重新載入該學程的文件列表
        if (result.success && result.successCount > 0) {
          await this.reloadProgramFiles(pId);
        }

      } catch (error) {
        console.error('Upload error:', error);
      } finally {
        this.uploading = false;
      }
    },

    // 重新載入特定學程的文件列表
    async reloadProgramFiles(pId) {
      const programIndex = this.userPrograms.findIndex(p => p.pId === pId);
      if (programIndex !== -1) {
        const filesResult = await applyStudentService.getDepartmentUploadFiles({
          asId: this.asId,
          pId: pId
        });

        if (filesResult.success) {
          this.userPrograms[programIndex].departmentFiles = filesResult.data;
        }
      }
    },

    // 格式化上傳時間
    formatUploadTime(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleString('zh-TW');
    },

    // 取得學位的顯示文字
    getDegreeText(degree) {
      const degreeMap = {
        8: "Bachelor",
        10: "Master",
        12: "Doctoral"
      };
      return degreeMap[degree] || "";
    },

    // Add and remove additional files
    addFileInput() {
      if (this.fileItems.length >= this.maxAdditionalFiles) {
        alert(`You can upload up to ${this.maxAdditionalFiles} additional files`);
        return;
      }
      this.fileItems.push({
        id: Date.now() + Math.random(), // Ensure uniqueness
        file: null,
      });
    },
    removeFileInput(id) {
      if (this.fileItems.length <= 1) {
        alert('At least one file field must be kept');
        return;
      }
      this.fileItems = this.fileItems.filter((item) => item.id !== id);
    },
    handleFileChange(event, id) {
      const file = event.target.files[0];
      const target = this.fileItems.find((item) => item.id === id);
      if (target) {
        target.file = file || null;
      }
    },

    // ========== 頁面導覽 ==========

    gotoApply_2() {
      this.$router.push("/Apply/2").then(() => {
        window.scrollTo(0, 0);
      });
    },
    /**
     * 回到上一頁（Form 1）
     */
    gotoPrev() {
      this.$router.push("/Apply/4").then(() => {
        window.scrollTo(0, 0);
      });
    },

    /**
     * 前往下一頁（Form 3）
     */
    gotoNext() {
      this.$router.push("/Apply/Check").then(() => {
        window.scrollTo(0, 0);
      });
    },

    /**
     * 切換表單元素的禁用狀態
     * @param {boolean} disable 是否禁用
     */
    toggleFormElements(disable) {
      // 使用 setTimeout 確保 DOM 已完全渲染
      setTimeout(() => {
        const container = document.querySelector('.box');
        if (!container) return;

        // 禁用所有 input (包含 text, radio, checkbox, file 等)
        const inputs = container.querySelectorAll('input:not(.tours_btn)');
        inputs.forEach(input => {
          input.disabled = disable;
        });

        // 禁用所有 select
        const selects = container.querySelectorAll('select');
        selects.forEach(select => {
          select.disabled = disable;
        });

        // 禁用所有 textarea
        const textareas = container.querySelectorAll('textarea');
        textareas.forEach(textarea => {
          textarea.disabled = disable;
        });

        // 禁用所有按鈕 (除了使用說明按鈕)
        const buttons = container.querySelectorAll('button:not(.tours_btn):not(.head-btn)');
        buttons.forEach(button => {
          button.disabled = disable;
        });
      }, 100);
    },
  },
};
</script>

<style scoped>
/* 當表單已提交時,禁用所有輸入元素 */
.submitted-readonly input,
.submitted-readonly select,
.submitted-readonly textarea,
.submitted-readonly button:not(.tours_btn) {
  pointer-events: none !important;
  opacity: 0.6 !important;
  cursor: not-allowed !important;
}

.submitted-readonly .form-check-input,
.submitted-readonly input[type="radio"],
.submitted-readonly input[type="checkbox"] {
  pointer-events: none !important;
  opacity: 0.6 !important;
  cursor: not-allowed !important;
}

.submitted-readonly .form-check-label {
  opacity: 0.6 !important;
  cursor: not-allowed !important;
}
</style>
